import requests from './requests';

export default {
    grant(code) {
        return requests
            .get('/trainer/wechat/grant', {
                params: {
                    code,
                },
            })
            .then(resp => resp.data);
    },
    getUser() {
        return requests
            .get('/trainer/wechat/user')
            .then(resp => resp.data);
    },
    getTrainer() {
        return requests
            .get('/trainer/wechat/trainer')
            .then(resp => resp.data);
    },
    jssdk(url) {
        return requests
            .post('/trainer/wechat/jssdk', {
                url,
            })
            .then(resp => resp.data);
    },
};



// WEBPACK FOOTER //
// ./src/api/wechat.js